import Divider from "@mui/material/Divider";
import "./DoorSensorTable.css";
import React from "react";
import SkeletonComponent from "./SkeletonComponent.tsx";
import { useDevicesContext } from "../../../context/DevicesContext.tsx";
import { useWebSocketContext } from "../../../context/WebSocketContext.tsx";

export default function DoorSensorTable() {
    const { data, isLoading } = useDevicesContext();
    const { socketData, isConnected } = useWebSocketContext();

    const formatDate = (dateSample) => {
        if (!dateSample) return "NA";
        const leftPart = dateSample.substring(0, dateSample.indexOf("T"));
        const rightPart = dateSample.substring(dateSample.indexOf("T") + 1, dateSample.indexOf("Z") - 4);
        const leftPartitions = leftPart.split("-");
        const formattedLeftPart = `${leftPartitions[2]}/${leftPartitions[1]}/${leftPartitions[0]}`;
        return `${formattedLeftPart} ${rightPart}`;
    };

    const mergedData = data?.map((backendItem) => {
        const socketItem = socketData?.find((socket) => socket.store_id === backendItem?._id);
        if (isConnected) {
            return socketItem?.door_sensor
                ? { ...backendItem, door_sensor: socketItem.door_sensor }
                : backendItem;
        } else {
            console.log( "backendItem",  backendItem)
            return backendItem; // Use backend data if WebSocket is disconnected
        }
    });

    return (
        <div className="devices-env-data-outer-container">
            <div style={{ paddingTop: "14px" }} className="devices-env-data-maincontainer">
                <div className="devices-heading-env-data">
                    <div className="devices-heading-env-data-store-name">
                        <span className="devices-heading-env-data-store-name-text">Store Name</span>
                    </div>
                    <div className="devices-heading-env-data-temperature">
                        <span className="devices-heading-env-data-temperature-text">Door Status</span>
                    </div>
                    <div className="devices-heading-env-data-humidity">
                        <span className="devices-heading-env-data-humidity-text">Battery</span>
                    </div>
                    <div className="devices-heading-env-data-humidity">
                        <span className="devices-heading-env-data-humidity-text">Last Updated</span>
                    </div>
                </div>
                {!isLoading && <Divider variant="middle" />}
                <div className="devices-env-dataContainer">
                    {isLoading ? (
                        <SkeletonComponent />
                    ) : (
                        <>
                            {mergedData 
                                ?.filter(
                                    (item) =>
                                        item?.door_sensor || item?.configs?.sensors?.door_sensor?.[0]
                                )
                                .map((item) => {
                                    const doorSensorData =
                                        item?.door_sensor || item?.configs?.sensors?.door_sensor?.[0] || {};
                                    console.log("Door Sensor Data Inside Map:", doorSensorData);

                                    return (
                                        <React.Fragment key={item?._id}>
                                            <div className="devices-env-data-box-container">
                                                <div className="devices-store-name">
                                                    <div className="devices-env-data-store-name-text">
                                                        {item.name || "Unknown Store"}
                                                    </div>
                                                </div>
                                                <div className="devices-env-data-box-humidity">
                                                    <span>{doorSensorData?.status || "N/A"}</span>
                                                </div>
                                                <div
                                                    className="devices-env-data-box-temperature"
                                                    style={{ color: "teal" }}
                                                >
                                                    <span>{doorSensorData?.battery || "N/A"}</span>
                                                </div>
                                                <div className="devices-env-data-box-humidity">
                                                    <span>
                                                        {formatDate(doorSensorData?.last_updated) || "N/A"}
                                                    </span>
                                                </div>
                                            </div>
                                            <Divider variant="middle" />
                                        </React.Fragment>
                                    );
                                })}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
